import { Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

import { themeColors } from '@/config/theme/themeColors.ts';
import { typography } from '@/config/theme/typography.ts';

export const FormFieldLabelBasicStyles: SystemStyleObject<Theme> = {
  ...typography.f12Regular,
  color: themeColors.greyDark,
  fontFamily: typography.fontFamily,
};

export const FormFieldLabelStyles: SystemStyleObject<Theme> = {
  ...FormFieldLabelBasicStyles,
  left: 0,
  position: 'absolute',
  top: -20,
};
